import React from 'react'
import Create from '../crud/create'
import fields from './fields'
import menuItems from './menuItems'

const CreatePage = (props) => {
  return (
    <Create
// @ts-ignore
      title='Create Page'
      fields={fields}
      apiPath='admin/pages'
      successRedirectPath={resource => `/write-now/pages/${resource.id}/edit`}
      buildMenuItems={menuItems}
    />
  )
}

export default CreatePage
